import { URLS, PERMISSIONS } from '_constants';
import privateRoutes from 'routes/private';

// Quick actions only target context-free "create" pages. Visit adds
// (assessment/education/enforcement) are intentionally absent: they have no
// standalone route and can only be created from a retailer context, so their
// `/x/add` paths fall through to the `/x/:id` view route and 404. Titles mirror
// each page's own `pageTitle` so the palette label matches the page it opens.
const ACTIONS = [
  {
    id: 'add-retailer',
    title: 'Add retailer',
    sectionTitle: 'data',
    path: URLS.retailersPages.add,
    permission: PERMISSIONS.ADD_RETAILER,
  },
  {
    id: 'add-campaign',
    title: 'Add campaign',
    sectionTitle: 'collect',
    path: URLS.campaignPages.add,
    permission: PERMISSIONS.ADD_CAMPAIGN,
  },
  {
    id: 'add-venue',
    title: 'Add venue',
    sectionTitle: 'data',
    path: URLS.venuesPages.add,
    permission: PERMISSIONS.ADD_VENUE,
  },
  {
    id: 'add-youth',
    title: 'Add youth',
    sectionTitle: 'data',
    path: URLS.youthPages.add,
    permission: PERMISSIONS.ADD_YOUTH,
  },
  {
    id: 'add-user',
    title: 'Add user',
    sectionTitle: 'users',
    path: URLS.userPages.add,
    permission: PERMISSIONS.ADD_USER,
  },
  {
    id: 'batch-upload-retailers',
    title: 'Batch upload retailers',
    sectionTitle: 'data',
    path: URLS.retailersPages.batchUpload,
    permission: PERMISSIONS.IMPORT_RETAILER,
  },
  {
    id: 'batch-upload-users',
    title: 'Batch upload users',
    sectionTitle: 'users',
    path: URLS.userPages.batchUpload,
    permission: PERMISSIONS.IMPORT_USERS,
  },
  {
    id: 'batch-upload-visits',
    title: 'Batch upload visits',
    sectionTitle: 'data',
    path: URLS.visitsPages.batchUpload,
    permission: PERMISSIONS.IMPORT_VISIT,
  },
];

// Paths backed by a real, context-free route (no `:` params). Anything else would
// 404, so we drop it — a safety net that keeps the action list honest if a URL or
// route ever drifts. Built lazily on first use to stay safe under import cycles.
let registeredStaticPaths;
const getRegisteredStaticPaths = () => {
  if (!registeredStaticPaths) {
    registeredStaticPaths = new Set(
      privateRoutes.map((route) => route.path).filter((path) => typeof path === 'string' && !path.includes(':')),
    );
  }
  return registeredStaticPaths;
};

export const getQuickActions = (userPermissions, modularityPermissions) => {
  // Mirror PrivateRoute: a route is reachable if the user OR modularity permissions grant it.
  const pool = [...(userPermissions || []), ...(modularityPermissions || [])];
  const registeredPaths = getRegisteredStaticPaths();
  return ACTIONS.filter(
    (action) => registeredPaths.has(action.path) && (!action.permission || pool.includes(action.permission)),
  ).map((action) => ({
    ...action,
    type: 'action',
    subtitle: 'Quick action',
  }));
};
